<template>
  <div>
    <span>{{ name }} was deleted.</span>
  </div>
</template>

<script>
import PropertiesMixin from "VueMixins/ActivityLog/PropertiesMixin";

export default {
  mixins: [PropertiesMixin],
  props: {
    rowProperties: {
      type: Object,
      required: true,
    },
  },
  computed: {
    name() {
      // This can be modified when we have more examples.
      const attribs = this.rowProperties.attributes;
      const old_attribs = this.rowProperties.old;

      return attribs?.name
        ?? attribs?.slug
        ?? old_attribs?.name
        ?? old_attribs?.slug
        ?? attribs?.uuid
        ?? old_attribs?.uuid
        ?? 'Unknown';
    },
  },
};
</script>
